import { createSlice } from "@reduxjs/toolkit";
import { logSessionInfo } from "../../../services/logger";

// Create initial state store and reducers
export const readerManagerSlice = createSlice({
  name: "readerManager",
  initialState: {
    contextStates: {
      readingMode: "",
      currentStoryId: "",
      currentWord: "",
      currentPhrase: "",
      currentAccuracy: 0,
      currentStory: null,
      currentPhraseErrors: 0,
      phraseEnded: false,
      snrTriggered: false,
      bgNoiseTriggered: false,
      detectionEnded: false,
      endingSequence: [],
    },
    isCurrentStoryStarted: false,
    isCurrentStoryEnded: false,
    readerManagerLogs: [],
  },
  reducers: {
    notifyStoryStarted: (state, action) => {
      state.isCurrentStoryStarted = action.payload
    },
    notifyStoryEnded: (state, action) => {
      state.isCurrentStoryEnded = action.payload
    },
    updateContextStates: (state, action) => {
      state.contextStates = {
        ...state.contextStates,
        ...action.payload
      }
    },
    addEndingSequence: (state, action) => {
      console.log("addEndingSequence", action.payload)
      state.contextStates.endingSequence.push(action.payload)
    },
    clearEndingSequence: (state) => {
      state.contextStates.endingSequence = []
    },
    replaceEndingSequence: (state, action) => {
      state.contextStates.endingSequence = [...action.payload]
    },
    logReaderManagerEvents: (state, action) => {
      state.readerManagerLogs.push({...action.payload, time: Date.now()})
    },
    clearReaderManagerLogs: (state) => {
      state.readerManagerLogs = []
    },
  }
});

// Export available action creators
export const {
  notifyStoryStarted,
  notifyStoryEnded,
  updateContextStates,
  addEndingSequence,
  clearEndingSequence,
  replaceEndingSequence,
  logReaderManagerEvents,
  clearReaderManagerLogs,
} = readerManagerSlice.actions;

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched
export const exampleThunk = () => (dispatch) => {

};

// Send logs to S3 as a thunk
export const sendReaderManagerLogsToS3 = () => (dispatch, getState) => {
  const { readerManagerLogs } = getState().readerManager;
  console.log("Send logs to S3: ", readerManagerLogs);
  logSessionInfo("ReaderManagerLogs", readerManagerLogs);
  dispatch(clearReaderManagerLogs());
};

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectReaderManager = (state) => state.readerManager

// Export the reducer
export default readerManagerSlice.reducer
